var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.role,
    _vm._g(
      {
        tag: "div",
        staticClass: "avatar",
        class: {
          "logged-in": _vm.loginState,
        },
      },
      _vm.$listeners
    ),
    [
      _vm.url || _vm.defaultUrl
        ? _c("img", {
            staticClass: "avatar__img",
            attrs: { src: _vm.url || _vm.defaultUrl },
          })
        : _c("i", { staticClass: "isif isif-account avatar__img" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }